import { render, staticRenderFns } from "./PanelCompetitionInsurance.vue?vue&type=template&id=557b41d8&scoped=true&"
import script from "./PanelCompetitionInsurance.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionInsurance.vue?vue&type=style&index=0&id=557b41d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b41d8",
  null
  
)

export default component.exports